import { render, staticRenderFns } from "./outline-switch.vue?vue&type=template&id=48936f65&scoped=true&"
import script from "./outline-switch.vue?vue&type=script&lang=js&"
export * from "./outline-switch.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48936f65",
  null
  
)

export default component.exports